import * as types from '../actions';

const initialState = {
    assocUsersAllData: [],
    departmentsList: [],
    rolesList: [],
    status:0,
    totalPage:0,
    numRows:0,
    count:'',
    errorData:'',
    activeUserData:{
        userId:'',
        firstName:'',
        lastName:'',
        contactNumber:'',
        emailAddress:'',  
        position:'',
        logo:'',
    },
    activity:'',
    assocUserDeptStatus: '',
    assocUserDeptActivity: '',
    assocUserRolesStatus: '',
    assocUserRolesActivity: '',
    assocUserAddStatus: '',
    assocUserAddActivity: '',
    assocUserData:[],
    assocUserUpdateData:[],
    assocUserGetStatus: '',
    assocUserGetActivity: '',
};

export default function(state = initialState, action) {
    const response = action.response;
    let timeVar = '~~'+Date.now()

    switch(action.type) {

        case types.DEPARTMENT_LIST_ASSOC_USER_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    departmentsList: response.data,
                    status: response.status,
                    activity: types.DEPARTMENT_LIST_ASSOC_USER_SUCCESS+timeVar,
                    assocUserDeptStatus: response.status,
                    assocUserDeptActivity: types.DEPARTMENT_LIST_ASSOC_USER_SUCCESS+timeVar
                };
            }
            else{
                return { ...state, response, status: response.status,    
                    activity: types.DEPARTMENT_LIST_ASSOC_USER_ERROR+timeVar,
                    assocUserDeptStatus: response.status,
                    assocUserDeptActivity: types.DEPARTMENT_LIST_ASSOC_USER_ERROR+timeVar 
                };
            }  
        case types.DEPARTMENT_LIST_ASSOC_USER_ERROR:
            return { ...state, response, status: response.status,    
                activity: types.DEPARTMENT_LIST_ASSOC_USER_ERROR+timeVar,
                assocUserDeptStatus: response.status,
                assocUserDeptActivity: types.DEPARTMENT_LIST_ASSOC_USER_ERROR+timeVar 
            }; 


        case types.ROLES_LIST_ASSOC_USER_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    rolesList: response.data.roles,
                    status: response.status,
                    statusText: response.statusText, 
                    activity: types.ROLES_LIST_ASSOC_USER_SUCCESS+timeVar,
                    assocUserRolesStatus: response.status,
                    assocUserRolesActivity: types.ROLES_LIST_ASSOC_USER_SUCCESS+timeVar,
                };
            }
            else {
                return {
                    status: response.status,
                    statusText: response.statusText, 
                    activity: types.ROLES_LIST_ASSOC_USER_ERROR+timeVar,
                    assocUserRolesStatus: response.status,
                    assocUserRolesActivity: types.ROLES_LIST_ASSOC_USER_ERROR+timeVar,
                    errorData: response.data,
                    ...state, response
                };
            }
        case types.ROLES_LIST_ASSOC_USER_ERROR:
            return {
                status: response.status,
                statusText: response.statusText, 
                activity: types.ROLES_LIST_ASSOC_USER_ERROR+timeVar,
                assocUserRolesStatus: response.status,
                assocUserRolesActivity: types.ROLES_LIST_ASSOC_USER_ERROR+timeVar,
                errorData: response.data,
                ...state, response
            };

        case types.UPDATE_ASSO_MUTE_EMAIL_SUCCESS:
            return {
                status: response.status,
                activity: types.UPDATE_ASSO_MUTE_EMAIL_SUCCESS+timeVar,
            };

        case types.UPDATE_ASSO_MUTE_PUSH_SUCCESS:
            return {
                status: response.status,
                activity: types.UPDATE_ASSO_MUTE_PUSH_SUCCESS+timeVar
            };

            
        case types.ASS_USER_LIST_SUCCESS:
            if(response.status===200){
                let totalPage = Math.ceil(response.data.count/response.data.page_size);
                return {
                    ...state,
                    assocUsersAllData: response.data.results,
                    status: response.status,
                    activity:types.ASS_USER_LIST_SUCCESS,
                    totalPage: totalPage,
                    numRows:response.data.results.length,
                    count:response.data.count               
                };
            }else{
                return {
                    ...state,
                    status: response.status, 
                    statusText: response.statusText,
                    errorData: response.data, 
                    activity:types.ASS_USER_LIST_ERROR,                                
                };
            }
        case types.ASS_USER_LIST_ERROR:
            return {
                ...state,
                status: response.status, 
                statusText: response.statusText,
                activity:types.ASS_USER_LIST_ERROR,                                
            };
        
         
        case types.ASS_USER_ADD_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    status: response.status,
                    activity:types.ASS_USER_ADD_SUCCESS+timeVar,
                    assocUserAddStatus: response.status,
                    assocUserAddActivity: types.ASS_USER_ADD_SUCCESS+timeVar,
                };
            }else{
                return {
                    ...state,
                    status: response.status, 
                    statusText: response.statusText,
                    errorData: response.data, 
                    activity:types.ASS_USER_ADD_ERROR+timeVar,   
                    assocUserAddStatus: response.status,
                    assocUserAddActivity: types.ASS_USER_ADD_ERROR+timeVar,                             
                };
            }
        case types.ASS_USER_ADD_ERROR:
            return {
                ...state,
                status: response.status, 
                statusText: response.statusText,
                errorData: response.data, 
                activity:types.ASS_USER_ADD_ERROR+timeVar,   
                assocUserAddStatus: response.status,
                assocUserAddActivity: types.ASS_USER_ADD_ERROR+timeVar,                                 
            };


        case types.ASS_USER_EDIT_SUCCESS:
            if(response.status===200){ 
                return {
                    ...state,
                    status:response.status,
                    subactivity:types.ASS_USER_EDIT_SUCCESS,
                    assocUserData: response.data,
                    assocUserGetStatus: response.status,
                    assocUserGetActivity: types.ASS_USER_EDIT_SUCCESS+timeVar,
                    contactUser:{
                        userId:response.data.user_id,
                        firstName:response.data.first_name,
                        lastName:response.data.last_name,
                        contactNumber:response.data.mobile,
                        emailAddress:response.data.email,  
                        position:response.data.position===null?'':response.data.position,
                        logo:response.data.profile_picture===null?'':response.data.profile_picture,
                        emailVerify:response.data.email_verified,
                        mute_mails:response.data.mute_mails,
                        mute_pushs:response.data.mute_pushs
                    }
                } 
            }else{
                return {
                    ...state,
                    status:response.status,
                    subactivity:types.ASS_USER_EDIT_ERROR,
                    assocUserGetStatus: response.status,
                    assocUserGetActivity: types.ASS_USER_EDIT_ERROR+timeVar,
                } 
            }
        case types.ASS_USER_EDIT_ERROR: 
            return {
                ...state,
                status:response.status,
                subactivity:types.ASS_USER_EDIT_ERROR,
                assocUserGetStatus: response.status,
                assocUserGetActivity: types.ASS_USER_EDIT_ERROR+timeVar,
            } 


        case types.ASS_USER_UPDATE_SUCCESS:
            if(response.status===200){
                return {
                    ...state,               
                    status:response.status,
                    statusText: response.statusText,
                    subactivity:types.ASS_USER_UPDATE_SUCCESS,
                    assocUserAddStatus: response.status,
                    assocUserAddActivity: types.ASS_USER_UPDATE_SUCCESS+timeVar,   
                    assocUserUpdateData:response.data,             
                } 
            }else{
                return {
                    ...state,               
                    status:response.status,
                    statusText: response.statusText,
                    subactivity:types.ASS_USER_UPDATE_ERROR, 
                    errorData:response.data,
                    assocUserAddStatus: response.status,
                    assocUserAddActivity: types.ASS_USER_UPDATE_ERROR+timeVar,                   
                } 
            } 
        case types.ASS_USER_UPDATE_ERROR:  
            return {
                ...state,               
                status:response.status,
                statusText: response.statusText,
                subactivity:types.ASS_USER_UPDATE_ERROR,
                assocUserAddStatus: response.status,
                assocUserAddActivity: types.ASS_USER_UPDATE_ERROR+timeVar,                   
            }  


        case types.ASS_USER_DELETE_SUCCESS:
            const userId = response.data.user_id;     
            if(response.status===200){ 
                return {
                    ...state,
                    items: state.contactList.filter(items => items.user.id !== userId),             
                    status: response.status,
                    subactivity:types.ASS_USER_DELETE_SUCCESS,   
                }
            }else{
                return {
                    ...state,
                    status: response.status?response.status:'',
                    subactivity:types.ASS_USER_DELETE_ERROR,   
                    errorData:response.data
                }
            }
        case types.ASS_USER_DELETE_ERROR:  
            return {
                ...state,
                status: response && response.status?response.status:'',
                subactivity:types.ASS_USER_DELETE_ERROR,   
                errorData: response && response.data?response.data:'',
            }
        case types.ASS_USER_ACTIVATE_SUCCESS:  
            if(response.status===200){ 
                return {
                    ...state,            
                    status: response.status,
                    subactivity:types.ASS_USER_ACTIVATE_SUCCESS,   
                }
            }else{
                return {
                    ...state,
                    status: response.status?response.status:'',
                    subactivity:types.ASS_USER_ACTIVATE_ERROR,   
                    errorData:response.data
                }
            }
        case types.ASS_USER_ACTIVATE_ERROR:  
            return {
                ...state,
                status: response && response.status?response.status:'',
                subactivity:types.ASS_USER_ACTIVATE_ERROR,   
                errorData: response && response.data?response.data:'',
            }

        case types.ASSOCIATE_USER_DELETE_SUCCESS: 
            if(response.status===200){ 
                return {
                    ...state,
                    status: response.status,
                    subactivity:types.ASSOCIATE_USER_DELETE_SUCCESS+timeVar,   
                }
            }else{
                return {
                    ...state,
                    status: response.status?response.status:'',
                    statusText: response.statusText,
                    subactivity:types.ASSOCIATE_USER_DELETE_ERROR+timeVar,   
                    errorData:response.data
                }
            }
        case types.ASSOCIATE_USER_DELETE_ERROR:  
            return {
                ...state,
                status: response.status?response.status:'',
                statusText: response.statusText,
                subactivity:types.ASSOCIATE_USER_DELETE_ERROR+timeVar,   
                errorData:response.data
            }    
        
        case types.RESEND_EMAIL_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    status:response.status,
                    activity:types.RESEND_EMAIL_SUCCESS,
                } 
            }else{
                return {
                    ...state,
                    status:response.status,
                    activity:types.RESEND_EMAIL_ERROR,
                    errorData:response.data
                } 
            }
        case types.RESEND_EMAIL_ERROR:
            return {
                ...state,
                status:response.status,
                activity:types.RESEND_EMAIL_ERROR,
                errorData:response.data
            } 


        case types.CLEAR:
            return {
                ...state,
                status:0,
                count:'',
                activity:types.CLEAR,
                subactivity:types.CLEAR
            } 
       
        default:
            return state;
    }
};